import { render, staticRenderFns } from "./TopRightMenu.vue?vue&type=template&id=18235756&"
import script from "./TopRightMenu.vue?vue&type=script&lang=js&"
export * from "./TopRightMenu.vue?vue&type=script&lang=js&"
import style0 from "./TopRightMenu.vue?vue&type=style&index=0&id=18235756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports